import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { ClientCountries, Country } from '@equipmyschool/emsadminweb-models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientCountriesService extends ServerBaseService {

  private _countries$ = new BehaviorSubject<Country[]>(null);  
  public countries$ = this._countries$.asObservable();

  private _clientCountries$ = new BehaviorSubject<ClientCountries[]>(null);  
  public clientCountries$ = this._clientCountries$.asObservable();

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl);
  }

  public getCountries () {
    this.request<Country[]>('GET', 'ClientCountry/Countries', null)
      .subscribe((response) => {
         this._countries$.next(response);
      });
  }

  public getClients () {
    this.request<ClientCountries[]>('GET', 'ClientCountry/Clients', null)
      .subscribe((response) => {
         this._clientCountries$.next(response);
      });
  }

  public updateClientCountries (client: number, countries: number[]) {
    this.request('POST', 'ClientCountry/ClientCountries', null, { Client: client, Countries: countries })
      .subscribe((response) => {

      });
  }
}


